function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".hero_svg__st9{fill:#192f28}.hero_svg__st14{fill:#fff}.hero_svg__st16{fill:#3eb883}.hero_svg__st17{fill:#7dc9a9}.hero_svg__st19{fill:#d1dde5}");

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 560.181,
  y1: 52.789,
  x2: 560.181,
  y2: 210.44
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.632,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M618.6 198.6H501.8V75.8h106.5c5.7 0 10.2 4.6 10.2 10.2v112.6z",
  fill: "url(#hero_svg__SVGID_1_)"
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 388.781,
  y1: 455.417,
  x2: 454.853,
  y2: 378
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_2_)",
  d: "M512 321.5v122.9H389.2V321.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 404.882,
  y1: 382.98,
  x2: 515.994,
  y2: 382.98
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.218,
  stopColor: "#2b3079"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.469,
  stopColor: "#252a6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#1c2154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M512 321.5v122.9c-67.9 0-122.9-55-122.9-122.9H512z",
  fill: "url(#hero_svg__SVGID_3_)"
});

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 226.408,
  y1: 246.386,
  x2: 191.413,
  y2: 69.394
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M266.3 198.6H143.4V86c0-5.7 4.6-10.2 10.2-10.2h112.7v122.8z",
  fill: "url(#hero_svg__SVGID_4_)"
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 324.352,
  y1: 60.144,
  x2: 335.793,
  y2: 322.604
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_5_)",
  d: "M266.3 75.8h122.9v122.9H266.3z"
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: 485.236,
  y1: 104.303,
  x2: 507.107,
  y2: 46.344
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M553 75.8H450.6V45h92.2c5.7 0 10.2 4.6 10.2 10.2v20.6z",
  fill: "url(#hero_svg__SVGID_6_)"
});

var _ref14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 348.193,
  y1: 52.332,
  x2: 348.193,
  y2: 96.282
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M460.8 75.8H235.5V55.3c0-5.7 4.6-10.2 10.2-10.2h204.8c5.7 0 10.2 4.6 10.2 10.2v20.5z",
  fill: "url(#hero_svg__SVGID_7_)"
});

var _ref16 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: 450.602,
  y1: 211.55,
  x2: 450.602,
  y2: 84.297
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M512 198.6L389.2 75.8h112.7c5.7 0 10.2 4.6 10.2 10.2v112.6z",
  fill: "url(#hero_svg__SVGID_8_)"
});

var _ref18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_9_",
  gradientUnits: "userSpaceOnUse",
  x1: 450.602,
  y1: 140.184,
  x2: 450.602,
  y2: 246.465
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.022,
  stopColor: "#eff2f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#c5cde7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.599,
  stopColor: "#a7b3da"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.834,
  stopColor: "#95a3d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_9_)",
  d: "M512 198.6H389.2V75.8z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M56.6 212.9c-.2.1-.4.2-.6.2-.5.1-1 0-1.6-.1-2-.5-3.8-1.7-5.6-2.6-2-1-4-2.1-5.8-3.3-2-1.2-4.9-3.1-7-1.1-.8.8-1 2-1.2 3.1-.4 3.1-.6 6.4-.2 9.5.1.7.2 1.3.6 1.9.3.4.7.7 1.1 1 1.6 1.2 3.3 2.1 5.2 2.7 1.3.4 2.6.6 4 .8 2.7.4 5.4.7 8.2.7 2.9 0 5.8-.4 8.7-.9 1.1-.2 2.1-.3 3.1-.8 2.4-1.2 3.4-4.1 3.8-6.8.2-1.2.3-2.4.3-3.7 0-.9.4-1.7.5-2.6.3-2.3-.3-4.9-1.2-7-.2-.4-.4-.8-.8-1.1-.6-.4-1.4-.2-1.9.2-.6.4-.9 1-1.3 1.5-.7 1-1.4 2-2.3 2.8-1 .9-1.9 2-2.9 2.9-.8 1-2 2.2-3.1 2.7z"
});

var _ref21 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_10_",
  gradientUnits: "userSpaceOnUse",
  x1: 34.326,
  y1: 214.335,
  x2: 70.146,
  y2: 214.335
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M56.6 212.9c-.2.1-.4.2-.6.2-.5.1-1 0-1.6-.1-2-.5-3.8-1.7-5.6-2.6-2-1-4-2.1-5.8-3.3-2-1.2-4.9-3.1-7-1.1-.8.8-1 2-1.2 3.1-.4 3.1-.6 6.4-.2 9.5.1.7.2 1.3.6 1.9.3.4.7.7 1.1 1 1.6 1.2 3.3 2.1 5.2 2.7 1.3.4 2.6.6 4 .8 2.7.4 5.4.7 8.2.7 2.9 0 5.8-.4 8.7-.9 1.1-.2 2.1-.3 3.1-.8 2.4-1.2 3.4-4.1 3.8-6.8.2-1.2.3-2.4.3-3.7 0-.9.4-1.7.5-2.6.3-2.3-.3-4.9-1.2-7-.2-.4-.4-.8-.8-1.1-.6-.4-1.4-.2-1.9.2-.6.4-.9 1-1.3 1.5-.7 1-1.4 2-2.3 2.8-1 .9-1.9 2-2.9 2.9-.8 1-2 2.2-3.1 2.7z",
  fill: "url(#hero_svg__SVGID_10_)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M66.1 200.3c2.3-14.1 27.1-16.5 27.3-9.7.5 16 7.9 18.6 8.5 30.4.6 11-3.6 16.8-11.4 19.7-9.3 3.4-17.7-2.1-23.8-10.9-5.7-8.4-1.9-21.8-.6-29.5z"
});

var _ref24 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_11_",
  gradientUnits: "userSpaceOnUse",
  x1: 43.606,
  y1: 291.241,
  x2: 97.389,
  y2: 188.37
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M66.1 200.3c2.3-14.1 27.1-16.5 27.3-9.7.5 16 7.9 18.6 8.5 30.4.6 11-3.6 16.8-11.4 19.7-9.3 3.4-17.7-2.1-23.8-10.9-5.7-8.4-1.9-21.8-.6-29.5z",
  fill: "url(#hero_svg__SVGID_11_)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M66.2 174.2c3.1-9.1-8.5-4.1-10-16.5-2.2 2.8-4.5 7.4-4 12.4.5 5.6-1.7 9.5.7 13.7 2.2 3.9 7.1 2.8 9.1.8 3.3-3.3 3-6.9 4.2-10.4z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M62.1 164.6c5.4-6.5 21.9-8.9 33.2 3.8 3.7 4.1-6.4 3.4-.1 12.6 9.2 13.5-23.5 25.5-32 23.6-1.1-.2-7.1-5.8-6.6-9.6-.8-1.7-.4-1.3-1-3-2.9-1.1-1.3-5.1-.6-6.3-2.3-3.1-2.4-5.6-1.8-7.8.7-2.8 6.5-10.5 8.9-13.3z"
});

var _ref28 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_12_",
  gradientUnits: "userSpaceOnUse",
  x1: 119.535,
  y1: 147.201,
  x2: 77.109,
  y2: 220.914,
  gradientTransform: "rotate(2.15 430.157 -253.668)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1 164.6c5.4-6.5 21.9-8.9 33.2 3.8 3.7 4.1-6.4 3.4-.1 12.6 9.2 13.5-23.5 25.5-32 23.6-1.1-.2-7.1-5.8-6.6-9.6-.8-1.7-.4-1.3-1-3-2.9-1.1-1.3-5.1-.6-6.3-2.3-3.1-2.4-5.6-1.8-7.8.7-2.8 6.5-10.5 8.9-13.3z",
  fill: "url(#hero_svg__SVGID_12_)"
});

var _ref30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "hero_svg__SVGID_13_",
  d: "M62.1 164.6c5.4-6.5 21.9-8.9 33.2 3.8 3.7 4.1-6.4 3.4-.1 12.6 9.2 13.5-23.5 25.5-32 23.6-2-.5-10.9-14.1-8.3-18.9-2.3-3.1-2.4-5.6-1.8-7.8.8-2.8 6.6-10.5 9-13.3z"
}));

var _ref31 = /*#__PURE__*/React.createElement("clipPath", {
  id: "hero_svg__SVGID_14_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hero_svg__SVGID_13_",
  overflow: "visible"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hero_svg__SVGID_14_)"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st14",
  d: "M52.6 193.4c-1-.5-2.4-1.5-2.3-2.5 0 0 0-.1.1-.1h.1c.7.8 1.9 1.1 3.2 1.2 0 0 .1 0 .1.1l-.9 1.3c-.2 0-.3.1-.3 0zm2.3 1l-1.5-.6c-.1 0-.1-.1 0-.1l1-1.4h.1l.6 2c0 .1-.1.2-.2.1zm.9 0l-.6-2.1c0-.1.1-.2.2-.3h.5c.4 0 .9-.1 1.5-.2h.1c.1 0 .3.1.3.2v.1l-1.8 2.3h-.2zm4.7.9c-1.2-.1-2.4-.2-3.6-.4-.2 0-.3-.2-.2-.3v-.1c.5-.7 1.8-2.3 2.1-2.7h.1l1.9 3.1c.1.1 0 .3-.2.4h-.1zm1.3-.2l-2-3.3c-.1-.1 0-.3.2-.4h.1c.5-.1.9-.2 1.4-.3.8-.2 1.6-.3 2.5-.4.1 0 .3.1.3.2v.1l-2.3 4.2c-.1 0-.1 0-.2-.1 0 .1 0 0 0 0zm4.7.2c-1.2.1-2.3.1-3.4.1-.2 0-.3-.1-.3-.3v-.1l1.9-3.6s.1-.1.1 0l1.9 3.5c.1.1 0 .3-.2.4.1 0 0 0 0 0zm1.2-.4l-.1.1h-.1l-2.2-4c-.1-.1 0-.3.2-.4h.1c.5-.1 1-.1 1.6-.2.6-.1 1.1-.1 1.6-.1.2 0 .4.1.4.3v.1l-1.5 4.2zm4.5-.3c-1 .2-2.2.3-3.4.5-.2 0-.4-.1-.4-.2v-.1l1.2-3.8.1-.1h.1l2.6 3.2c.1.1.1.3-.1.4 0 .1-.1.1-.1.1zm1.1-.5l-3-3.7c-.1-.1 0-.2.1-.3h4.2c.1 0 .3.1.3.2v.1l-1.4 3.7h-.2zm4.9-1.1c-1.1.4-2.3.8-3.5 1.1-.2 0-.4 0-.4-.2v-.2l1.3-3.4s.1-.1.1 0c.4.4 1.9 1.7 2.6 2.3.2.1.1.2-.1.4.1 0 0 0 0 0zm1.2-2.9l-.2 2.2s0 .1-.1.1H79l-2.2-1.9c-.1-.1-.1-.2 0-.3 0 0 .1-.1.2-.1h.1c.5 0 1-.1 1.5-.1h.5c.2-.1.3-.1.3.1zm2.1 1.2c-.4.3-.9.6-1.4.9-.1.1-.2 0-.2-.1l.2-2s0-.1.1-.1h.1l1.3 1.2-.1.1zm1.2-1c-.2.1-.3.3-.5.4h-.1l-1.2-1.1v-.1c.8-.2 1.4-.4 1.9-.7.4-.3.8-.6 1-1 0 0 .1-.1.1 0v.4c.2.6-.3 1.3-1.2 2.1z",
  id: "hero_svg__Teeth_11_"
}));

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M111.4 153.4c-.2-.1-.5-.2-.8-.2-.2 0-.4.1-.6.3-6.1 5.4-11.3 6.8-14.8 7.8-1.7.5-3 .8-4 1.5-.9.6-1.6 1.4-2.1 2.4-1.9 4.1.5 16.6 7.1 19.8 2.6 0 4.8-.6 6.4-1.6l-1.9-3.2 4 1.4c1.6-1.9 2.6-4.1 3-6.4l-2.8-1.6 3.2-.9c0-.7.1-1.3.1-1.8-.1-5.7 2.4-10.8 3-13.2.1-.5.6-2.5.7-2.9.1-.6-.1-1.1-.5-1.4z"
});

var _ref34 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_15_",
  gradientUnits: "userSpaceOnUse",
  x1: 131.404,
  y1: 154.032,
  x2: 88.977,
  y2: 227.745,
  gradientTransform: "rotate(2.15 430.157 -253.668)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M111.4 153.4c-.2-.1-.5-.2-.8-.2-.2 0-.4.1-.6.3-6.1 5.4-11.3 6.8-14.8 7.8-1.7.5-3 .8-4 1.5-.9.6-1.6 1.4-2.1 2.4-1.9 4.1.5 16.6 7.1 19.8 2.6 0 4.8-.6 6.4-1.6l-1.9-3.2 4 1.4c1.6-1.9 2.6-4.1 3-6.4l-2.8-1.6 3.2-.9c0-.7.1-1.3.1-1.8-.1-5.7 2.4-10.8 3-13.2.1-.5.6-2.5.7-2.9.1-.6-.1-1.1-.5-1.4z",
  fill: "url(#hero_svg__SVGID_15_)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M93 172.7c.5-1.7.9-4.2 5.7-6.7h.1c.9-.5 3.3-1.4 5.7-3.3 4.9-3.8 7.4-8 7.4-8-.1.4-.6 2.4-.7 2.9-.6 2.4-3.1 7.5-3 13.2 0 .6 0 1.2-.1 1.8l-3.2.9 2.8 1.6c-.4 2.3-1.4 4.5-3 6.4l-4-1.4 1.9 3.2c-1.5.9-3.1 1.5-6.4 1.6-.2-.4-.3-.8-.5-1.2-1.5-3.3-3.6-7.9-2.7-11zm-25.8-8.2c-.6-.3-2.9.6-2.9.6-.5.2-.8.8-.4 1 .9.4 1.8.4 2.6-.1 1.1-.4 1.4-1.2.7-1.5zm.8 2.5c-1.3.4-.2 1.7.6 1.7s2-.8 1.7-1.3c-.3-.5-1.6-.6-2.3-.4zm3.5-3.8c-1 .1-1.9 1.6-1.9 2.1 0 .6.8.7 2.5.6 1.7-.1 3.1-1.4 2.9-1.9 0-.6-2.5-1-3.5-.8z"
});

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_38_"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow__x2B__Eyes_38_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M68.7 182.9c-1.3 0-2.2-.2-2.2-.2s1.3-.7 3.2-1.8c5-2.9 8-6.5 10.8-6.8 1.7-.2 2.5 2.1 2.5 2.1-.9-.2-1.9-.2-2.8 0-1.6.3-3.3 1.4-5.3 2.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st16",
  d: "M74.8 178.9c3.3-1.3 5-1.3 5-1.3.2.7.2 1.3.2 2-.1 2.5-1.5 5-5.2 5.6-2.3.4-4.6-.4-6.1-2.3"
})));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_37_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st17",
  d: "M73.2 180.8c2.3-1.2 3.7-1.3 3.7-1.3.1.4.1.8.1 1.2 0 1.4-.9 2.9-3.1 3.3-1.3.3-2.7-.3-3.6-1.3.1-.1.6-.7 2.9-1.9z",
  id: "hero_svg__Brow__x2B__Eyes_37_"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_36_"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow__x2B__Eyes_36_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M57.6 182.2c-1.3-.6-2.3-1-3.1-.9-.5.1-1 .3-1.4.6 0 0-.1-1.8.8-2 1.4-.3 3.7 1.7 6.7 2.7 1.1.4 2.3.6 2.4.7.2 0-.9.3-1.6.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st16",
  d: "M61.4 183.9c-.3 1.6-1.3 2.7-2.5 2.8-1.9.3-3.1-1.2-3.7-2.9-.2-.5-.3-1-.3-1.5 0 0 .8-.3 2.7 0"
})));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_35_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st17",
  d: "M58.8 183.5c-1.3-.4-2-.2-2-.2 0 .3.1.5.1.7.3.9.9 1.6 2 1.5.7-.1 1.2-.6 1.5-1.4 0 0-.3-.3-1.6-.6z",
  id: "hero_svg__Brow__x2B__Eyes_35_"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st14",
  d: "M72.1 181.5s-1.7.5-1.7 1.3 2.5-1 3.1-1.3c.7-.3.1-.6-1.4 0zm-13.3 2.1s1.1.1 1.3.7c.2.6-1.7-.3-2.1-.4-.5-.2-.2-.5.8-.3zm-3 10.8l-.6-2.1c0-.1.1-.2.2-.3h.5c.4 0 .9-.1 1.5-.2h.1c.1 0 .3.1.3.2v.1l-1.8 2.3h-.2zm6 .7l-2-3.3c-.1-.1 0-.3.2-.4h.1c.5-.1.9-.2 1.4-.3.8-.2 1.6-.3 2.5-.4.1 0 .3.1.3.2v.1l-2.3 4.2c-.1 0-.1 0-.2-.1 0 .1 0 0 0 0zm5.9-.2l-.1.1h-.1l-2.2-4c-.1-.1 0-.3.2-.4h.1c.5-.1 1-.1 1.6-.2.6-.1 1.1-.1 1.6-.1.2 0 .4.1.4.3v.1l-1.5 4.2zm5.6-.8l-3-3.7c-.1-.1 0-.2.1-.3h4.2c.1 0 .3.1.3.2v.1l-1.4 3.7h-.2zm6.1-4l-.2 2.2s0 .1-.1.1H79l-2.2-1.9c-.1-.1-.1-.2 0-.3 0 0 .1-.1.2-.1h.1c.5 0 1-.1 1.5-.1h.5c.2-.1.3-.1.3.1z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M32.1 208.9c-.5.5-.9 1.1-1.2 1.7-1.1 2.2-.3 4.6.4 6.8.2.8.5 1.7 1.2 2.1.8.5 2 .5 2.9.8 1.1.4 2.5.3 3.7.1 2.1-.4 3.7-1.9 2.8-4.1-.9-2.1-2.3 1.2-2.3 1.2s6.7-1.1 2.8-6.4c-1.1-.2-1.4 1.9-1.4 1.9 0-.2.8-.7.9-.8.5-.6.9-1.4.6-2.2-.8-2.8-5-3.6-7.4-2.8-1.3.2-2.3.9-3 1.7z"
});

var _ref43 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_16_",
  gradientUnits: "userSpaceOnUse",
  x1: 30.331,
  y1: 213.735,
  x2: 43.404,
  y2: 213.735
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1 208.9c-.5.5-.9 1.1-1.2 1.7-1.1 2.2-.3 4.6.4 6.8.2.8.5 1.7 1.2 2.1.8.5 2 .5 2.9.8 1.1.4 2.5.3 3.7.1 2.1-.4 3.7-1.9 2.8-4.1-.9-2.1-2.3 1.2-2.3 1.2s6.7-1.1 2.8-6.4c-1.1-.2-1.4 1.9-1.4 1.9 0-.2.8-.7.9-.8.5-.6.9-1.4.6-2.2-.8-2.8-5-3.6-7.4-2.8-1.3.2-2.3.9-3 1.7z",
  fill: "url(#hero_svg__SVGID_16_)"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st19",
  cx: 36.9,
  cy: 204.8,
  r: 5.1
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M627.8 115.6c.2.1.4.2.6.2.5.1 1 0 1.6-.1 2-.5 3.8-1.7 5.6-2.6 2-1 4-2.1 5.8-3.3 2-1.2 4.9-3.1 7-1.1.8.8 1 2 1.2 3.1.4 3.1.6 6.4.2 9.5-.1.7-.2 1.3-.6 1.9-.3.4-.7.7-1.1 1-1.6 1.2-3.3 2.1-5.2 2.7-1.3.4-2.6.6-4 .8-2.7.4-5.4.7-8.2.7-2.9 0-5.8-.4-8.7-.9-1.1-.2-2.1-.3-3.1-.8-2.4-1.2-3.4-4.1-3.8-6.8-.2-1.2-.3-2.4-.3-3.7 0-.9-.4-1.7-.5-2.6-.3-2.3.3-4.9 1.2-7 .2-.4.4-.8.8-1.1.6-.4 1.4-.2 1.9.2.6.4.9 1 1.3 1.5.7 1 1.4 2 2.3 2.8 1 .9 1.9 2 2.9 2.9.8 1 2 2.2 3.1 2.7z"
});

var _ref47 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_17_",
  gradientUnits: "userSpaceOnUse",
  x1: 1232.215,
  y1: 117.059,
  x2: 1268.035,
  y2: 117.059,
  gradientTransform: "matrix(-1 0 0 1 1882.295 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M627.8 115.6c.2.1.4.2.6.2.5.1 1 0 1.6-.1 2-.5 3.8-1.7 5.6-2.6 2-1 4-2.1 5.8-3.3 2-1.2 4.9-3.1 7-1.1.8.8 1 2 1.2 3.1.4 3.1.6 6.4.2 9.5-.1.7-.2 1.3-.6 1.9-.3.4-.7.7-1.1 1-1.6 1.2-3.3 2.1-5.2 2.7-1.3.4-2.6.6-4 .8-2.7.4-5.4.7-8.2.7-2.9 0-5.8-.4-8.7-.9-1.1-.2-2.1-.3-3.1-.8-2.4-1.2-3.4-4.1-3.8-6.8-.2-1.2-.3-2.4-.3-3.7 0-.9-.4-1.7-.5-2.6-.3-2.3.3-4.9 1.2-7 .2-.4.4-.8.8-1.1.6-.4 1.4-.2 1.9.2.6.4.9 1 1.3 1.5.7 1 1.4 2 2.3 2.8 1 .9 1.9 2 2.9 2.9.8 1 2 2.2 3.1 2.7z",
  fill: "url(#hero_svg__SVGID_17_)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M618.3 103c-2.3-14.1-27.1-16.5-27.3-9.7-.5 16-7.9 18.6-8.5 30.4-.6 11 3.6 16.8 11.4 19.7 9.3 3.4 17.7-2.1 23.8-10.9 5.7-8.4 1.9-21.8.6-29.5z"
});

var _ref50 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_18_",
  gradientUnits: "userSpaceOnUse",
  x1: 1241.496,
  y1: 193.965,
  x2: 1295.279,
  y2: 91.094,
  gradientTransform: "matrix(-1 0 0 1 1882.295 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M618.3 103c-2.3-14.1-27.1-16.5-27.3-9.7-.5 16-7.9 18.6-8.5 30.4-.6 11 3.6 16.8 11.4 19.7 9.3 3.4 17.7-2.1 23.8-10.9 5.7-8.4 1.9-21.8.6-29.5z",
  fill: "url(#hero_svg__SVGID_18_)"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M618.2 76.9c-3.1-9.1 8.5-4.1 10-16.5 2.2 2.8 4.5 7.4 4 12.4-.5 5.6 1.7 9.5-.7 13.7-2.2 3.9-7.1 2.8-9.1.8-3.2-3.3-3-6.9-4.2-10.4z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M622.3 67.3c-5.4-6.5-21.9-8.9-33.2 3.8-3.7 4.1 6.4 3.4.1 12.6-9.2 13.5 23.5 25.5 32 23.6 1.1-.2 7.1-5.8 6.6-9.6.8-1.7.4-1.3 1-3 2.9-1.1 1.3-5.1.6-6.3 2.3-3.1 2.4-5.6 1.8-7.8-.7-2.8-6.5-10.5-8.9-13.3z"
});

var _ref54 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_19_",
  gradientUnits: "userSpaceOnUse",
  x1: 1312.933,
  y1: 5.062,
  x2: 1270.506,
  y2: 78.775,
  gradientTransform: "scale(-1 1) rotate(2.15 -510.987 -50418.11)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M622.3 67.3c-5.4-6.5-21.9-8.9-33.2 3.8-3.7 4.1 6.4 3.4.1 12.6-9.2 13.5 23.5 25.5 32 23.6 1.1-.2 7.1-5.8 6.6-9.6.8-1.7.4-1.3 1-3 2.9-1.1 1.3-5.1.6-6.3 2.3-3.1 2.4-5.6 1.8-7.8-.7-2.8-6.5-10.5-8.9-13.3z",
  fill: "url(#hero_svg__SVGID_19_)"
});

var _ref56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "hero_svg__SVGID_20_",
  d: "M622.3 67.3c-5.4-6.5-21.9-8.9-33.2 3.8-3.7 4.1 6.4 3.4.1 12.6-9.2 13.5 23.5 25.5 32 23.6 2-.5 10.9-14.1 8.3-18.9 2.3-3.1 2.4-5.6 1.8-7.8-.8-2.8-6.6-10.5-9-13.3z"
}));

var _ref57 = /*#__PURE__*/React.createElement("clipPath", {
  id: "hero_svg__SVGID_21_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hero_svg__SVGID_20_",
  overflow: "visible"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hero_svg__SVGID_21_)"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st14",
  d: "M631.8 96.2c1-.5 2.4-1.5 2.3-2.5 0 0 0-.1-.1-.1h-.1c-.7.8-1.9 1.1-3.2 1.2 0 0-.1 0-.1.1l.9 1.3h.3zm-2.3.9l1.5-.6c.1 0 .1-.1 0-.1l-1-1.4h-.1l-.6 2c0 .1.1.2.2.1zm-.9 0l.6-2.1c0-.1-.1-.2-.2-.3h-.5c-.4 0-.9-.1-1.5-.2h-.1c-.1 0-.3.1-.3.2v.1l1.8 2.3h.2zm-4.7 1c1.2-.1 2.4-.2 3.6-.4.2 0 .3-.2.2-.3v-.1c-.5-.7-1.8-2.3-2.1-2.7h-.1l-1.9 3.1c-.1.1 0 .3.2.4h.1zm-1.3-.2l2-3.3c.1-.1 0-.3-.2-.4h-.1c-.5-.1-.9-.2-1.4-.3-.8-.2-1.6-.3-2.5-.4-.1 0-.3.1-.3.2v.1l2.3 4.2c.1-.1.1-.1.2-.1zm-4.7.1c1.2.1 2.3.1 3.4.1.2 0 .3-.1.3-.3v-.1l-1.9-3.6s-.1-.1-.1 0l-1.9 3.5c-.1.1 0 .3.2.4-.1 0 0 0 0 0zm-1.2-.4l.1.1h.1l2.2-4c.1-.1 0-.3-.2-.4h-.1c-.5-.1-1-.1-1.6-.2-.6-.1-1.1-.1-1.6-.1-.2 0-.4.1-.4.3v.1l1.5 4.2zm-4.5-.3c1 .2 2.2.3 3.4.5.2 0 .4-.1.4-.2v-.1l-1.2-3.8-.1-.1h-.1l-2.6 3.2c-.1.1-.1.3.1.4 0 .1.1.1.1.1zm-1.1-.5l3-3.7c.1-.1 0-.2-.1-.3h-4.2c-.1 0-.3.1-.3.2v.1l1.4 3.7s.1.1.2 0c0 .1 0 0 0 0zm-4.9-1.1c1.1.4 2.3.8 3.5 1.1.2 0 .4 0 .4-.2v-.2l-1.3-3.4s-.1-.1-.1 0c-.4.4-1.9 1.7-2.6 2.3-.1.1-.1.3.1.4-.1 0 0 0 0 0zm-1.2-2.9l.2 2.2s0 .1.1.1h.1l2.2-1.9c.1-.1.1-.2 0-.3 0 0-.1-.1-.2-.1h-.1c-.5 0-1-.1-1.5-.1h-.5c-.1-.1-.3 0-.3.1zm-2.1 1.2c.4.3.9.6 1.4.9.1.1.2 0 .2-.1l-.2-2s0-.1-.1-.1h-.1l-1.3 1.2s0 .1.1.1zm-1.2-.9c.2.1.3.3.5.4h.1l1.2-1.1v-.1c-.8-.2-1.4-.4-1.9-.7-.4-.3-.8-.6-1-1 0 0-.1-.1-.1 0v.4c-.1.5.3 1.3 1.2 2.1z",
  id: "hero_svg__Teeth_1_"
}));

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M573 56.1c.2-.1.5-.2.8-.2.2 0 .4.1.6.3 6.1 5.4 11.3 6.8 14.8 7.8 1.7.5 3 .8 4 1.5.9.6 1.6 1.4 2.1 2.4 1.9 4.1-.5 16.6-7.1 19.8-2.6 0-4.8-.6-6.4-1.6l1.9-3.2-4 1.4c-1.6-1.9-2.6-4.1-3-6.4l2.8-1.6-3.2-.9c0-.7-.1-1.3-.1-1.8.1-5.7-2.4-10.8-3-13.2-.1-.5-.6-2.5-.7-2.9-.1-.6.1-1.1.5-1.4z"
});

var _ref60 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_22_",
  gradientUnits: "userSpaceOnUse",
  x1: 1324.802,
  y1: 11.893,
  x2: 1282.375,
  y2: 85.606,
  gradientTransform: "scale(-1 1) rotate(2.15 -510.987 -50418.11)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M573 56.1c.2-.1.5-.2.8-.2.2 0 .4.1.6.3 6.1 5.4 11.3 6.8 14.8 7.8 1.7.5 3 .8 4 1.5.9.6 1.6 1.4 2.1 2.4 1.9 4.1-.5 16.6-7.1 19.8-2.6 0-4.8-.6-6.4-1.6l1.9-3.2-4 1.4c-1.6-1.9-2.6-4.1-3-6.4l2.8-1.6-3.2-.9c0-.7-.1-1.3-.1-1.8.1-5.7-2.4-10.8-3-13.2-.1-.5-.6-2.5-.7-2.9-.1-.6.1-1.1.5-1.4z",
  fill: "url(#hero_svg__SVGID_22_)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M591.4 75.4c-.5-1.7-.9-4.2-5.7-6.7h-.1c-.9-.5-3.3-1.4-5.7-3.3-4.9-3.8-7.4-8-7.4-8 .1.4.6 2.4.7 2.9.6 2.4 3.1 7.5 3 13.2 0 .6 0 1.2.1 1.8l3.2.9-2.8 1.6c.4 2.3 1.4 4.5 3 6.4l4-1.4-1.9 3.2c1.5.9 3.1 1.5 6.4 1.6.2-.4.3-.8.5-1.2 1.5-3.2 3.6-7.9 2.7-11zM617.2 67.2c.6-.3 2.9.6 2.9.6.5.2.8.8.4 1-.9.4-1.8.4-2.6-.1-1.1-.4-1.4-1.2-.7-1.5zm-.8 2.5c1.3.4.2 1.7-.6 1.7s-2-.8-1.7-1.3c.3-.5 1.6-.6 2.3-.4zm-3.5-3.8c1 .1 1.9 1.6 1.9 2.1 0 .6-.8.7-2.5.6-1.7-.1-3.1-1.4-2.9-1.9 0-.5 2.5-.9 3.5-.8z"
});

var _ref63 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_4_"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow__x2B__Eyes_4_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M615.7 85.6c1.3 0 2.2-.2 2.2-.2s-1.3-.7-3.2-1.8c-5-2.9-8-6.5-10.8-6.8-1.7-.2-2.5 2.1-2.5 2.1.9-.2 1.9-.2 2.8 0 1.6.3 3.3 1.4 5.3 2.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st16",
  d: "M609.6 81.6c-3.3-1.3-5-1.3-5-1.3-.2.7-.2 1.3-.2 2 .1 2.5 1.5 5 5.2 5.6 2.3.4 4.6-.4 6.1-2.3"
})));

var _ref64 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_3_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st17",
  d: "M611.2 83.5c-2.3-1.2-3.7-1.3-3.7-1.3-.1.4-.1.8-.1 1.2 0 1.4.9 2.9 3.1 3.3 1.3.3 2.7-.3 3.6-1.3-.1 0-.6-.6-2.9-1.9z",
  id: "hero_svg__Brow__x2B__Eyes_3_"
}));

var _ref65 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_2_"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow__x2B__Eyes_2_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M626.8 85c1.3-.6 2.3-1 3.1-.9.5.1 1 .3 1.4.6 0 0 .1-1.8-.8-2-1.4-.3-3.7 1.7-6.7 2.7-1.1.4-2.3.6-2.4.7-.2 0 .9.3 1.6.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st16",
  d: "M623 86.6c.3 1.6 1.3 2.7 2.5 2.8 1.9.3 3.1-1.2 3.7-2.9.2-.5.3-1 .3-1.5 0 0-.8-.3-2.7 0"
})));

var _ref66 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st17",
  d: "M625.7 86.2c1.3-.4 2-.2 2-.2 0 .3-.1.5-.1.7-.3.9-.9 1.6-2 1.5-.7-.1-1.2-.6-1.5-1.4-.1 0 .2-.2 1.6-.6z",
  id: "hero_svg__Brow__x2B__Eyes_1_"
}));

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st14",
  d: "M612.3 84.2s1.7.5 1.7 1.3-2.5-1-3.1-1.3c-.7-.3-.1-.6 1.4 0zm13.3 2.1s-1.1.1-1.3.7c-.2.6 1.7-.3 2.1-.4.5-.2.2-.5-.8-.3zM628.6 97.1l.6-2.1c0-.1-.1-.2-.2-.3h-.5c-.4 0-.9-.1-1.5-.2h-.1c-.1 0-.3.1-.3.2v.1l1.8 2.3h.2zm-6 .8l2-3.3c.1-.1 0-.3-.2-.4h-.1c-.5-.1-.9-.2-1.4-.3-.8-.2-1.6-.3-2.5-.4-.1 0-.3.1-.3.2v.1l2.3 4.2c.1-.1.1-.1.2-.1zm-5.9-.3l.1.1h.1l2.2-4c.1-.1 0-.3-.2-.4h-.1c-.5-.1-1-.1-1.6-.2-.6-.1-1.1-.1-1.6-.1-.2 0-.4.1-.4.3v.1l1.5 4.2zm-5.6-.8l3-3.7c.1-.1 0-.2-.1-.3h-4.2c-.1 0-.3.1-.3.2v.1l1.4 3.7s.1.1.2 0c0 .1 0 0 0 0zm-6.1-4l.2 2.2s0 .1.1.1h.1l2.2-1.9c.1-.1.1-.2 0-.3 0 0-.1-.1-.2-.1h-.1c-.5 0-1-.1-1.5-.1h-.5c-.1-.1-.3 0-.3.1z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M652.3 111.6c.5.5.9 1.1 1.2 1.7 1.1 2.2.3 4.6-.4 6.8-.2.8-.5 1.7-1.2 2.1-.8.5-2 .5-2.9.8-1.1.4-2.5.3-3.7.1-2.1-.4-3.7-1.9-2.8-4.1.9-2.1 2.3 1.2 2.3 1.2s-6.7-1.1-2.8-6.4c1.1-.2 1.4 1.9 1.4 1.9 0-.2-.8-.7-.9-.8-.5-.6-.9-1.4-.6-2.2.8-2.8 5-3.6 7.4-2.8 1.3.3 2.3.9 3 1.7z"
});

var _ref69 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_23_",
  gradientUnits: "userSpaceOnUse",
  x1: 1228.221,
  y1: 116.459,
  x2: 1241.293,
  y2: 116.459,
  gradientTransform: "matrix(-1 0 0 1 1882.295 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M652.3 111.6c.5.5.9 1.1 1.2 1.7 1.1 2.2.3 4.6-.4 6.8-.2.8-.5 1.7-1.2 2.1-.8.5-2 .5-2.9.8-1.1.4-2.5.3-3.7.1-2.1-.4-3.7-1.9-2.8-4.1.9-2.1 2.3 1.2 2.3 1.2s-6.7-1.1-2.8-6.4c1.1-.2 1.4 1.9 1.4 1.9 0-.2-.8-.7-.9-.8-.5-.6-.9-1.4-.6-2.2.8-2.8 5-3.6 7.4-2.8 1.3.3 2.3.9 3 1.7z",
  fill: "url(#hero_svg__SVGID_23_)"
});

var _ref71 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st19",
  cx: 647.5,
  cy: 107.5,
  r: 5.1
});

var _ref72 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_24_",
  gradientUnits: "userSpaceOnUse",
  x1: 98.313,
  y1: 229.366,
  x2: 133.132,
  y2: 229.366
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M98.3 219.1H129c2.3 0 4.1 1.8 4.1 4.1v16.4H98.3v-20.5z",
  fill: "url(#hero_svg__SVGID_24_)"
});

var _ref74 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_25_",
  gradientUnits: "userSpaceOnUse",
  x1: 325.56,
  y1: 222.815,
  x2: 335.571,
  y2: 396.338
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref75 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_25_)",
  d: "M266.3 198.6h122.9v122.9H266.3z"
});

var _ref76 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_26_",
  gradientUnits: "userSpaceOnUse",
  x1: 164.401,
  y1: 222.918,
  x2: 235.892,
  y2: 288.664
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.218,
  stopColor: "#2b3079"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.469,
  stopColor: "#252a6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#1c2154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
}));

var _ref77 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_26_)",
  d: "M143.4 198.6h122.9v122.9H143.4z"
});

var _ref78 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_27_",
  gradientUnits: "userSpaceOnUse",
  x1: 144.23,
  y1: 381.956,
  x2: 192.608,
  y2: 381.956
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.218,
  stopColor: "#2b3079"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.469,
  stopColor: "#252a6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#1c2154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
}));

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_27_)",
  d: "M143.4 321.5h122.9v120.8H143.4z"
});

var _ref80 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_28_",
  gradientUnits: "userSpaceOnUse",
  x1: 327.711,
  y1: 341.013,
  x2: 327.711,
  y2: 381.145
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref81 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_28_)",
  d: "M266.3 321.5h122.9v122.9H266.3z"
});

var _ref82 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_29_",
  gradientUnits: "userSpaceOnUse",
  x1: 366.294,
  y1: 486.732,
  x2: 321.018,
  y2: 390.52
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref83 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_29_)",
  d: "M245.8 321.5h143.4v122.9H245.8z"
});

var _ref84 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_30_",
  gradientUnits: "userSpaceOnUse",
  x1: 174.096,
  y1: 438.255,
  x2: 174.096,
  y2: 469.745
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M250.9 444.4H97.3v-26.6c0-2.3 1.8-4.1 4.1-4.1h149.5v30.7z",
  fill: "url(#hero_svg__SVGID_30_)"
});

var _ref86 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_31_",
  gradientUnits: "userSpaceOnUse",
  x1: 209.94,
  y1: 400.696,
  x2: 209.94,
  y2: 430.027
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M287.8 413.7H128v-26.6c0-2.3 1.8-4.1 4.1-4.1h159.8v26.6c0 2.3-1.9 4.1-4.1 4.1z",
  fill: "url(#hero_svg__SVGID_31_)"
});

var _ref88 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_32_",
  gradientUnits: "userSpaceOnUse",
  x1: 240.663,
  y1: 369.826,
  x2: 240.663,
  y2: 401.248
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M318.5 383H158.7v-26.6c0-2.3 1.8-4.1 4.1-4.1h159.8v26.6c0 2.2-1.8 4.1-4.1 4.1z",
  fill: "url(#hero_svg__SVGID_32_)"
});

var _ref90 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_33_",
  gradientUnits: "userSpaceOnUse",
  x1: 271.385,
  y1: 339.103,
  x2: 271.385,
  y2: 370.526
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M349.2 352.3H189.5v-26.6c0-2.3 1.8-4.1 4.1-4.1h159.8v26.6c-.1 2.2-1.9 4.1-4.2 4.1z",
  fill: "url(#hero_svg__SVGID_33_)"
});

var _ref92 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_34_",
  gradientUnits: "userSpaceOnUse",
  x1: 256.584,
  y1: 280.57,
  x2: 88.491,
  y2: 280.57
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref93 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_34_)",
  d: "M118.8 239.6h147.5v81.9H118.8z"
});

var _ref94 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_35_",
  gradientUnits: "userSpaceOnUse",
  x1: 58.844,
  y1: 260.714,
  x2: 92.736,
  y2: 519.329
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.022,
  stopColor: "#eff2f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#c5cde7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.599,
  stopColor: "#a7b3da"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.834,
  stopColor: "#95a3d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
}));

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M118.8 321.5H4.1c-2.3 0-4.1-1.8-4.1-4.1v-73.7c0-2.3 1.8-4.1 4.1-4.1h114.7c2.3 0 4.1 1.8 4.1 4.1v73.7c0 2.3-1.8 4.1-4.1 4.1z",
  fill: "url(#hero_svg__SVGID_35_)"
});

var _ref96 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_36_",
  gradientUnits: "userSpaceOnUse",
  x1: 61.994,
  y1: 262.661,
  x2: 61.37,
  y2: 227.091
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M98.3 219.1H24.6c-2.3 0-4.1 1.8-4.1 4.1v16.4h81.9v-16.4c0-2.2-1.8-4.1-4.1-4.1z",
  fill: "url(#hero_svg__SVGID_36_)"
});

var _ref98 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_37_",
  gradientUnits: "userSpaceOnUse",
  x1: 401.02,
  y1: 211.811,
  x2: 451.742,
  y2: 261.198
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.218,
  stopColor: "#2b3079"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.469,
  stopColor: "#252a6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#1c2154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
}));

var _ref99 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_37_)",
  d: "M389.2 198.6h122.9v122.9H389.2z"
});

var _ref100 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_38_",
  gradientUnits: "userSpaceOnUse",
  x1: 600.328,
  y1: 382.98,
  x2: 520.073,
  y2: 382.98
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M618.6 321.5v112.7c0 5.7-4.6 10.2-10.2 10.2H512V321.5h106.6z",
  fill: "url(#hero_svg__SVGID_38_)"
});

var _ref102 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_39_",
  gradientUnits: "userSpaceOnUse",
  x1: 594.539,
  y1: 259.533,
  x2: 489.09,
  y2: 261.536
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.218,
  stopColor: "#2b3079"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.469,
  stopColor: "#252a6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#1c2154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
}));

var _ref103 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_39_)",
  d: "M512 198.6h106.5v122.9H512z"
});

var _ref104 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_40_",
  gradientUnits: "userSpaceOnUse",
  x1: 596.281,
  y1: 167.92,
  x2: 505.476,
  y2: 167.92
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref105 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_40_)",
  d: "M512 137.2h106.5v61.4H512z"
});

var _ref106 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_41_",
  gradientUnits: "userSpaceOnUse",
  x1: 546.77,
  y1: 167.92,
  x2: 656.485,
  y2: 167.92
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M675.9 198.6h-98.3c-2.3 0-4.1-1.8-4.1-4.1v-53.3c0-2.3 1.8-4.1 4.1-4.1h98.3c2.3 0 4.1 1.8 4.1 4.1v53.3c0 2.3-1.8 4.1-4.1 4.1z",
  fill: "url(#hero_svg__SVGID_41_)"
});

var _ref108 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_42_",
  gradientUnits: "userSpaceOnUse",
  x1: 283.675,
  y1: 117.739,
  x2: 293.916,
  y2: 117.739
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref109 = /*#__PURE__*/React.createElement("circle", {
  cx: 288.8,
  cy: 117.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_42_)"
});

var _ref110 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_43_",
  gradientUnits: "userSpaceOnUse",
  x1: 303.132,
  y1: 117.739,
  x2: 313.373,
  y2: 117.739
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref111 = /*#__PURE__*/React.createElement("circle", {
  cx: 308.3,
  cy: 117.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_43_)"
});

var _ref112 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_44_",
  gradientUnits: "userSpaceOnUse",
  x1: 322.59,
  y1: 117.739,
  x2: 332.831,
  y2: 117.739
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref113 = /*#__PURE__*/React.createElement("circle", {
  cx: 327.7,
  cy: 117.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_44_)"
});

var _ref114 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_45_",
  gradientUnits: "userSpaceOnUse",
  x1: 342.048,
  y1: 117.739,
  x2: 352.289,
  y2: 117.739
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref115 = /*#__PURE__*/React.createElement("circle", {
  cx: 347.2,
  cy: 117.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_45_)"
});

var _ref116 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_46_",
  gradientUnits: "userSpaceOnUse",
  x1: 283.675,
  y1: 137.197,
  x2: 293.916,
  y2: 137.197
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref117 = /*#__PURE__*/React.createElement("circle", {
  cx: 288.8,
  cy: 137.2,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_46_)"
});

var _ref118 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_47_",
  gradientUnits: "userSpaceOnUse",
  x1: 303.132,
  y1: 137.197,
  x2: 313.373,
  y2: 137.197
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref119 = /*#__PURE__*/React.createElement("circle", {
  cx: 308.3,
  cy: 137.2,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_47_)"
});

var _ref120 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_48_",
  gradientUnits: "userSpaceOnUse",
  x1: 322.59,
  y1: 137.197,
  x2: 332.831,
  y2: 137.197
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref121 = /*#__PURE__*/React.createElement("circle", {
  cx: 327.7,
  cy: 137.2,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_48_)"
});

var _ref122 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_49_",
  gradientUnits: "userSpaceOnUse",
  x1: 342.048,
  y1: 137.197,
  x2: 352.289,
  y2: 137.197
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref123 = /*#__PURE__*/React.createElement("circle", {
  cx: 347.2,
  cy: 137.2,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_49_)"
});

var _ref124 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_50_",
  gradientUnits: "userSpaceOnUse",
  x1: 283.675,
  y1: 156.655,
  x2: 293.916,
  y2: 156.655
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref125 = /*#__PURE__*/React.createElement("circle", {
  cx: 288.8,
  cy: 156.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_50_)"
});

var _ref126 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_51_",
  gradientUnits: "userSpaceOnUse",
  x1: 303.132,
  y1: 156.655,
  x2: 313.373,
  y2: 156.655
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref127 = /*#__PURE__*/React.createElement("circle", {
  cx: 308.3,
  cy: 156.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_51_)"
});

var _ref128 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_52_",
  gradientUnits: "userSpaceOnUse",
  x1: 322.59,
  y1: 156.655,
  x2: 332.831,
  y2: 156.655
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref129 = /*#__PURE__*/React.createElement("circle", {
  cx: 327.7,
  cy: 156.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_52_)"
});

var _ref130 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_53_",
  gradientUnits: "userSpaceOnUse",
  x1: 342.048,
  y1: 156.655,
  x2: 352.289,
  y2: 156.655
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref131 = /*#__PURE__*/React.createElement("circle", {
  cx: 347.2,
  cy: 156.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_53_)"
});

var _ref132 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_54_",
  gradientUnits: "userSpaceOnUse",
  x1: 283.675,
  y1: 176.113,
  x2: 293.916,
  y2: 176.113
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref133 = /*#__PURE__*/React.createElement("circle", {
  cx: 288.8,
  cy: 176.1,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_54_)"
});

var _ref134 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_55_",
  gradientUnits: "userSpaceOnUse",
  x1: 303.132,
  y1: 176.113,
  x2: 313.373,
  y2: 176.113
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref135 = /*#__PURE__*/React.createElement("circle", {
  cx: 308.3,
  cy: 176.1,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_55_)"
});

var _ref136 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_56_",
  gradientUnits: "userSpaceOnUse",
  x1: 322.59,
  y1: 176.113,
  x2: 332.831,
  y2: 176.113
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref137 = /*#__PURE__*/React.createElement("circle", {
  cx: 327.7,
  cy: 176.1,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_56_)"
});

var _ref138 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_57_",
  gradientUnits: "userSpaceOnUse",
  x1: 342.048,
  y1: 176.113,
  x2: 352.289,
  y2: 176.113
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref139 = /*#__PURE__*/React.createElement("circle", {
  cx: 347.2,
  cy: 176.1,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_57_)"
});

var _ref140 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_58_",
  gradientUnits: "userSpaceOnUse",
  x1: 361.506,
  y1: 117.739,
  x2: 371.747,
  y2: 117.739
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref141 = /*#__PURE__*/React.createElement("circle", {
  cx: 366.6,
  cy: 117.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_58_)"
});

var _ref142 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_59_",
  gradientUnits: "userSpaceOnUse",
  x1: 283.675,
  y1: 98.281,
  x2: 293.916,
  y2: 98.281
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref143 = /*#__PURE__*/React.createElement("circle", {
  cx: 288.8,
  cy: 98.3,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_59_)"
});

var _ref144 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_60_",
  gradientUnits: "userSpaceOnUse",
  x1: 303.132,
  y1: 98.281,
  x2: 313.373,
  y2: 98.281
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref145 = /*#__PURE__*/React.createElement("circle", {
  cx: 308.3,
  cy: 98.3,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_60_)"
});

var _ref146 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_61_",
  gradientUnits: "userSpaceOnUse",
  x1: 322.59,
  y1: 98.281,
  x2: 332.831,
  y2: 98.281
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 327.7,
  cy: 98.3,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_61_)"
}));

var _ref147 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_62_",
  gradientUnits: "userSpaceOnUse",
  x1: 342.048,
  y1: 98.281,
  x2: 352.289,
  y2: 98.281
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 347.2,
  cy: 98.3,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_62_)"
}));

var _ref148 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_63_",
  gradientUnits: "userSpaceOnUse",
  x1: 361.506,
  y1: 98.281,
  x2: 371.747,
  y2: 98.281
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 366.6,
  cy: 98.3,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_63_)"
}));

var _ref149 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_64_",
  gradientUnits: "userSpaceOnUse",
  x1: 361.506,
  y1: 137.197,
  x2: 371.747,
  y2: 137.197
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 366.6,
  cy: 137.2,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_64_)"
}));

var _ref150 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_65_",
  gradientUnits: "userSpaceOnUse",
  x1: 361.506,
  y1: 156.655,
  x2: 371.747,
  y2: 156.655
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 366.6,
  cy: 156.7,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_65_)"
}));

var _ref151 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_66_",
  gradientUnits: "userSpaceOnUse",
  x1: 361.506,
  y1: 176.113,
  x2: 371.747,
  y2: 176.113
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.159,
  stopColor: "#13183d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.383,
  stopColor: "#1c224f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.646,
  stopColor: "#2b326d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#404997"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 366.6,
  cy: 176.1,
  r: 5.1,
  fill: "url(#hero_svg__SVGID_66_)"
}));

var _ref152 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_67_",
  gradientUnits: "userSpaceOnUse",
  x1: 584.927,
  y1: 129.516,
  x2: 565.162,
  y2: 129.516
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.218,
  stopColor: "#2b3079"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.469,
  stopColor: "#252a6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.737,
  stopColor: "#1c2154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
})), /*#__PURE__*/React.createElement("path", {
  d: "M597 121.8h-26.6c-2.3 0-4.1 1.8-4.1 4.1v11.3H597v-15.4z",
  fill: "url(#hero_svg__SVGID_67_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_68_",
  gradientUnits: "userSpaceOnUse",
  x1: 624.441,
  y1: 148.956,
  x2: 628.007,
  y2: 121.85
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M657.5 121.8H596c-2.3 0-4.1 1.8-4.1 4.1v11.3h69.6v-11.3c.1-2.2-1.8-4.1-4-4.1z",
  fill: "url(#hero_svg__SVGID_68_)"
}));

var _ref153 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_69_",
  gradientUnits: "userSpaceOnUse",
  x1: 82.763,
  y1: 220.839,
  x2: 83.284,
  y2: 196.34
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_69_)",
  d: "M81.4 204.8h3.1v14.3h-3.1z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st19",
  cx: 83,
  cy: 203.8,
  r: 5.1
}));

var _ref154 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M89.2 219.1s-2.5 2.3-7.5 2.2-3.9-4.3-3.9-4.3c-1.1-2.1.7-2.7.7-2.7-.1.1-.6-1.4-.6-1.5 0-.6.2-1.1.5-1.6.6-1.1 1.6-1.8 2.9-2-.1 0 .2.9.3 1 .6.7 1.3.5 2 .2 1-.3 2.1-1.2 3.2-1 1.9.3 3.3 1.8 4.2 3.4 3.5 5.8-4.4-11.1.9-16.1 5.4-5.1 13.5 9.9 13.7 22.5H89.2z"
});

var _ref155 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_70_",
  gradientUnits: "userSpaceOnUse",
  x1: 83.76,
  y1: 191.048,
  x2: 94.411,
  y2: 224.669
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M89.2 219.1s-2.5 2.3-7.5 2.2-3.9-4.3-3.9-4.3c-1.1-2.1.7-2.7.7-2.7-.1.1-.6-1.4-.6-1.5 0-.6.2-1.1.5-1.6.6-1.1 1.6-1.8 2.9-2-.1 0 .2.9.3 1 .6.7 1.3.5 2 .2 1-.3 2.1-1.2 3.2-1 1.9.3 3.3 1.8 4.2 3.4 3.5 5.8-4.4-11.1.9-16.1 5.4-5.1 13.5 9.9 13.7 22.5H89.2z",
  fill: "url(#hero_svg__SVGID_70_)"
});

var _ref157 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_71_",
  gradientUnits: "userSpaceOnUse",
  x1: 1280.652,
  y1: 123.563,
  x2: 1281.174,
  y2: 99.064,
  gradientTransform: "matrix(-1 0 0 1 1882.295 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_71_)",
  d: "M599.9 121.8h3.1v-14.3h-3.1z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st19",
  cx: 601.5,
  cy: 106.5,
  r: 5.1
}));

var _ref158 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M595.2 121.8s2.5 2.3 7.5 2.2c5-.2 3.9-4.3 3.9-4.3 1.1-2.1-.7-2.7-.7-2.7.1.1.6-1.4.6-1.5 0-.6-.2-1.1-.5-1.6-.6-1.1-1.6-1.8-2.9-2 .1 0-.2.9-.3 1-.6.7-1.3.5-2 .2-1-.3-2.1-1.2-3.2-1-1.9.3-3.3 1.8-4.2 3.4-3.5 5.8 4.4-11.1-.9-16.1-5.4-5.1-13.5 9.9-13.7 22.5h16.4z"
});

var _ref159 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_72_",
  gradientUnits: "userSpaceOnUse",
  x1: 1281.649,
  y1: 93.772,
  x2: 1292.3,
  y2: 127.393,
  gradientTransform: "matrix(-1 0 0 1 1882.295 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M595.2 121.8s2.5 2.3 7.5 2.2c5-.2 3.9-4.3 3.9-4.3 1.1-2.1-.7-2.7-.7-2.7.1.1.6-1.4.6-1.5 0-.6-.2-1.1-.5-1.6-.6-1.1-1.6-1.8-2.9-2 .1 0-.2.9-.3 1-.6.7-1.3.5-2 .2-1-.3-2.1-1.2-3.2-1-1.9.3-3.3 1.8-4.2 3.4-3.5 5.8 4.4-11.1-.9-16.1-5.4-5.1-13.5 9.9-13.7 22.5h16.4z",
  fill: "url(#hero_svg__SVGID_72_)"
});

var _ref161 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_73_",
  gradientUnits: "userSpaceOnUse",
  x1: 526.799,
  y1: 260.089,
  x2: 436.436,
  y2: 260.089
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M512 321.5H389.2c0-67.9 55-122.9 122.9-122.9v122.9z",
  fill: "url(#hero_svg__SVGID_73_)"
});

var _ref163 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_74_",
  gradientUnits: "userSpaceOnUse",
  x1: 458.648,
  y1: 285.691,
  x2: 523.796,
  y2: 285.691
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
}));

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M512 321.5h-71.7c0-39.6 32.1-71.7 71.7-71.7v71.7z",
  fill: "url(#hero_svg__SVGID_74_)"
});

var _ref165 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_75_",
  gradientUnits: "userSpaceOnUse",
  x1: 515.309,
  y1: 357.378,
  x2: 466.76,
  y2: 357.378
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
}));

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M512 321.5v71.7c-39.6 0-71.7-32.1-71.7-71.7H512z",
  fill: "url(#hero_svg__SVGID_75_)"
});

var _ref167 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_76_",
  gradientUnits: "userSpaceOnUse",
  x1: 525.819,
  y1: 260.089,
  x2: 593.463,
  y2: 260.089
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 301.1c-22.6 0-41-18.3-41-41s18.3-41 41-41h34.8V301h-34.8z",
  fill: "url(#hero_svg__SVGID_76_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_77_",
  gradientUnits: "userSpaceOnUse",
  x1: 642.038,
  y1: 260.089,
  x2: 513.291,
  y2: 260.089
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 608.3,
  cy: 260.1,
  r: 41,
  fill: "url(#hero_svg__SVGID_77_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_78_",
  gradientUnits: "userSpaceOnUse",
  x1: 594.949,
  y1: 260.089,
  x2: 638.577,
  y2: 260.089
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 608.3,
  cy: 260.1,
  r: 25.6,
  fill: "url(#hero_svg__SVGID_78_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_79_",
  gradientUnits: "userSpaceOnUse",
  x1: 525.819,
  y1: 382.98,
  x2: 593.463,
  y2: 382.98
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M573.5 423.9c-22.6 0-41-18.3-41-41s18.3-41 41-41h34.8v81.9h-34.8z",
  fill: "url(#hero_svg__SVGID_79_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_80_",
  gradientUnits: "userSpaceOnUse",
  x1: 642.038,
  y1: 382.98,
  x2: 513.291,
  y2: 382.98
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 608.3,
  cy: 383,
  r: 41,
  fill: "url(#hero_svg__SVGID_80_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_81_",
  gradientUnits: "userSpaceOnUse",
  x1: 594.949,
  y1: 382.98,
  x2: 638.577,
  y2: 382.98
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.631,
  stopColor: "#616db3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#454fa1"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 608.3,
  cy: 383,
  r: 25.6,
  fill: "url(#hero_svg__SVGID_81_)"
}));

var _ref168 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_82_",
  gradientUnits: "userSpaceOnUse",
  x1: 167.952,
  y1: 154.168,
  x2: 167.952,
  y2: 101.583
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.282,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#151940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.762,
  stopColor: "#1f2352"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("path", {
  d: "M168 182.3c-2.8 0-5.1-2.3-5.1-5.1V99.3c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v77.8c0 2.9-2.3 5.2-5.1 5.2z",
  fill: "url(#hero_svg__SVGID_82_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_83_",
  gradientUnits: "userSpaceOnUse",
  x1: 167.952,
  y1: 89.706,
  x2: 167.952,
  y2: 231.777
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M168 182.3c-2.8 0-5.1-2.3-5.1-5.1v-45.1c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v45.1c0 2.8-2.3 5.1-5.1 5.1z",
  fill: "url(#hero_svg__SVGID_83_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_84_",
  gradientUnits: "userSpaceOnUse",
  x1: 186.386,
  y1: 171.605,
  x2: 186.386,
  y2: 119.224
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.282,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#151940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.762,
  stopColor: "#1f2352"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186.4 182.3c-2.8 0-5.1-2.3-5.1-5.1V99.3c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v77.8c0 2.9-2.3 5.2-5.1 5.2z",
  fill: "url(#hero_svg__SVGID_84_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_85_",
  gradientUnits: "userSpaceOnUse",
  x1: 186.386,
  y1: 93.661,
  x2: 186.386,
  y2: 229.66
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186.4 182.3c-2.8 0-5.1-2.3-5.1-5.1v-14.3c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v14.3c0 2.8-2.3 5.1-5.1 5.1z",
  fill: "url(#hero_svg__SVGID_85_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_86_",
  gradientUnits: "userSpaceOnUse",
  x1: 204.819,
  y1: 160.98,
  x2: 204.819,
  y2: 105.606
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.282,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#151940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.762,
  stopColor: "#1f2352"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("path", {
  d: "M204.8 182.3c-2.8 0-5.1-2.3-5.1-5.1V99.3c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v77.8c0 2.9-2.3 5.2-5.1 5.2z",
  fill: "url(#hero_svg__SVGID_86_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_87_",
  gradientUnits: "userSpaceOnUse",
  x1: 204.819,
  y1: 90.451,
  x2: 204.819,
  y2: 231.378
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M204.8 182.3c-2.8 0-5.1-2.3-5.1-5.1v-34.8c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v34.8c0 2.8-2.3 5.1-5.1 5.1z",
  fill: "url(#hero_svg__SVGID_87_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_88_",
  gradientUnits: "userSpaceOnUse",
  x1: 223.253,
  y1: 125.016,
  x2: 223.253,
  y2: 90.58
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.282,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#151940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.762,
  stopColor: "#1f2352"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("path", {
  d: "M223.3 182.3c-2.8 0-5.1-2.3-5.1-5.1V99.3c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v77.8c0 2.9-2.3 5.2-5.1 5.2z",
  fill: "url(#hero_svg__SVGID_88_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_89_",
  gradientUnits: "userSpaceOnUse",
  x1: 223.253,
  y1: 91.33,
  x2: 223.253,
  y2: 230.908
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M223.3 182.3c-2.8 0-5.1-2.3-5.1-5.1v-63.5c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v63.5c0 2.8-2.3 5.1-5.1 5.1z",
  fill: "url(#hero_svg__SVGID_89_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_90_",
  gradientUnits: "userSpaceOnUse",
  x1: 241.687,
  y1: 168.881,
  x2: 241.687,
  y2: 106.102
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.282,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#151940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.762,
  stopColor: "#1f2352"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("path", {
  d: "M241.7 182.3c-2.8 0-5.1-2.3-5.1-5.1V99.3c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v77.8c0 2.9-2.3 5.2-5.1 5.2z",
  fill: "url(#hero_svg__SVGID_90_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_91_",
  gradientUnits: "userSpaceOnUse",
  x1: 241.687,
  y1: 91.61,
  x2: 241.687,
  y2: 230.758
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#d6dcef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("path", {
  d: "M241.7 182.3c-2.8 0-5.1-2.3-5.1-5.1v-24.6c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1v24.6c0 2.8-2.3 5.1-5.1 5.1z",
  fill: "url(#hero_svg__SVGID_91_)"
}));

var _ref169 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_92_",
  gradientUnits: "userSpaceOnUse",
  x1: 251.438,
  y1: 260.089,
  x2: 438.21,
  y2: 260.089
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.164,
  stopColor: "#262b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.503,
  stopColor: "#1a1e4f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.793,
  stopColor: "#13173d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
})), /*#__PURE__*/React.createElement("path", {
  d: "M370.7 309.2h-86c-3.4 0-6.1-2.8-6.1-6.1v-86c0-3.4 2.8-6.1 6.1-6.1h86c3.4 0 6.1 2.8 6.1 6.1v86c.1 3.4-2.7 6.1-6.1 6.1z",
  fill: "url(#hero_svg__SVGID_92_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_93_",
  gradientUnits: "userSpaceOnUse",
  x1: 283.675,
  y1: 208.217,
  x2: 283.675,
  y2: 298.261
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.282,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.427,
  stopColor: "#151940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.762,
  stopColor: "#1f2352"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("path", {
  d: "M288.8 309.2h-4.1c-3.4 0-6.1-2.8-6.1-6.1v-86c0-3.4 2.8-6.1 6.1-6.1h4.1v98.2z",
  fill: "url(#hero_svg__SVGID_93_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.3 226.8h-15.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h15.2c.8 0 1.5.7 1.5 1.5.1.8-.6 1.5-1.5 1.5zm-24.7 0h-5.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5.2c.8 0 1.5.7 1.5 1.5.1.8-.6 1.5-1.5 1.5zm-12.9 0h-9.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm49.8 11.3h-15c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h15c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-24 0h-22.3c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h22.3c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm-30.6 0h-4.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h4.8c.8 0 1.5.7 1.5 1.5.1.8-.6 1.5-1.5 1.5zm54.6 11.2h-6.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h6.7c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-14.9 0H312c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h33.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-41.1 0h-3.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h3.4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm48.6 11.3h-20.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h20.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-27.7 0h-24.3c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h24.3c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm35.1 11.3h-39.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h39.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-49 0h-1.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h1.4c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm-9 0h-1.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h1.4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm54.9 11.2H353c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h4.4c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm-13.6 0h-42.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h42.7c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm-2.4 11.3h-3.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h3.9c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zm-13.4 0h-12.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H328c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm-21.1 0h-5.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5.8c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z",
  fill: "#e7edf2"
}));

var _ref170 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M366.4 34.1c-8.5-3.1-39.9-4-50.2 4.6-2.3 2.6-7.7 6.8-7.7 6.8l69.9-.3s-3.5-8-12-11.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M373.1 35.4c-9.9 1-19.1 1-23.9 5.4-4.8 4.3-2.3 14.6.2 15.2 1.7.5.1-3 2.9-5.1-.4 3.4 3.7 7.2 5.4 7.5 1.7.3-1.8-4.4 1.1-6.4 1.3 3.3 4.9 4.3 5.4 3.4.4-.6-2.8-3.4-.3-5.7 3.3 1.1 17.8 4.4 21.6-2.6s-3.5-12.6-12.4-11.7zm-59.6 0c9.9.9 19 1.1 23.9 5.3 6.2 5.4 2.1 15.3.1 15.8-1 .3-1.1-4.3-3.5-5.4 1.2 4-2.7 7.4-3.7 7.3-1-.1.1-4.6-2.4-6.7-1.2 3.7-5.9 5.3-6.5 4.5-.5-.7 3.6-4.9 1.3-6.5 0 0-17.8 4.4-21.6-2.5-3.8-6.9 3.5-12.6 12.4-11.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_94_",
  gradientUnits: "userSpaceOnUse",
  x1: 376.331,
  y1: 66.475,
  x2: 359.966,
  y2: 33.48
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M373.1 35.4c-9.9 1-19.1 1-23.9 5.4-4.8 4.3-2.3 14.6.2 15.2 1.7.5.1-3 2.9-5.1-.4 3.4 3.7 7.2 5.4 7.5 1.7.3-1.8-4.4 1.1-6.4 1.3 3.3 4.9 4.3 5.4 3.4.4-.6-2.8-3.4-.3-5.7 3.3 1.1 17.8 4.4 21.6-2.6s-3.5-12.6-12.4-11.7z",
  fill: "url(#hero_svg__SVGID_94_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_95_",
  gradientUnits: "userSpaceOnUse",
  x1: 309.114,
  y1: 73.287,
  x2: 326.535,
  y2: 32.109
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M313.5 35.4c9.9.9 19 1.1 23.9 5.3 6.2 5.4 2.1 15.3.1 15.8-1 .3-1.1-4.3-3.5-5.4 1.2 4-2.7 7.4-3.7 7.3-1-.1.1-4.6-2.4-6.7-1.2 3.7-5.9 5.3-6.5 4.5-.5-.7 3.6-4.9 1.3-6.5 0 0-17.8 4.4-21.6-2.5-3.8-6.9 3.5-12.6 12.4-11.8z",
  fill: "url(#hero_svg__SVGID_95_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M384.9.7c-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.3 0-.5.1-.6.2-6.6 4.4-11.8 5.1-15.3 5.6-1.7.2-3.1.4-4.1.9-.9.5-1.7 1.2-2.4 2-3.5-4.3-9-6.5-16.4-6.5h-1.5c-7.4 0-12.9 2.1-16.4 6.4-.6-.8-1.4-1.5-2.4-2-1.1-.5-2.4-.7-4.1-.9-3.4-.5-8.7-1.2-15.3-5.6-.2-.1-.4-.2-.6-.2-.3 0-.5.1-.7.3-.4.3-.5.8-.3 1.3.2.4.9 2.2 1.1 2.7.8 2.2 4 6.8 4.6 12.4.1.5.2 1.2.3 1.8l3.2.5-2.5 1.9c.7 2.2 2 4.2 3.7 5.8l3.7-1.9-1.4 3.4c1.7.7 3.9 1 6.4.7-.4 1.6-.5 2.8-.4 3.8.3 2.6 1.7 3.9 2.7 4.7 2.1 1.7 5.4 2.9 10.1 3.7.9.3 1.5.9 1.9 1.7.4 1.2 2.7 1.8 7 1.9h.2c2.5 0 4.4-.2 5.6-.7 1-.3 1.3-.8 1.5-1.2.4-.8 1.1-1.4 1.9-1.7 4.9-.8 8.3-2.1 10.4-3.9 2-1.8 2.3-3.7 2.4-5v-.1c0-1.1-.2-2.2-.4-3.2.8.1 1.7.2 2.5.1l-.4-3.3 2.2 2.9.2-1.9 1.4 1.5c1.9-.8 3.5-2.2 4.6-3.9l-3.7-3.2 4.8 1.1c.7-1.4 1.2-2.9 1.4-4.4l-2.1-1.1s2.4-.3 2.4-.4l-3.1-1.5h3.3c1-4.8 3.7-8.7 4.4-10.7.2-.5.9-2.3 1.1-2.7.1-.1.1-.3.1-.5.1-.3-.4-.8-1-.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_96_",
  gradientUnits: "userSpaceOnUse",
  x1: 344.131,
  y1: -41.456,
  x2: 347.299,
  y2: 77.06
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M384.9.7c-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.3 0-.5.1-.6.2-6.6 4.4-11.8 5.1-15.3 5.6-1.7.2-3.1.4-4.1.9-.9.5-1.7 1.2-2.4 2-3.5-4.3-9-6.5-16.4-6.5h-1.5c-7.4 0-12.9 2.1-16.4 6.4-.6-.8-1.4-1.5-2.4-2-1.1-.5-2.4-.7-4.1-.9-3.4-.5-8.7-1.2-15.3-5.6-.2-.1-.4-.2-.6-.2-.3 0-.5.1-.7.3-.4.3-.5.8-.3 1.3.2.4.9 2.2 1.1 2.7.8 2.2 4 6.8 4.6 12.4.1.5.2 1.2.3 1.8l3.2.5-2.5 1.9c.7 2.2 2 4.2 3.7 5.8l3.7-1.9-1.4 3.4c1.7.7 3.9 1 6.4.7-.4 1.6-.5 2.8-.4 3.8.3 2.6 1.7 3.9 2.7 4.7 2.1 1.7 5.4 2.9 10.1 3.7.9.3 1.5.9 1.9 1.7.4 1.2 2.7 1.8 7 1.9h.2c2.5 0 4.4-.2 5.6-.7 1-.3 1.3-.8 1.5-1.2.4-.8 1.1-1.4 1.9-1.7 4.9-.8 8.3-2.1 10.4-3.9 2-1.8 2.3-3.7 2.4-5v-.1c0-1.1-.2-2.2-.4-3.2.8.1 1.7.2 2.5.1l-.4-3.3 2.2 2.9.2-1.9 1.4 1.5c1.9-.8 3.5-2.2 4.6-3.9l-3.7-3.2 4.8 1.1c.7-1.4 1.2-2.9 1.4-4.4l-2.1-1.1s2.4-.3 2.4-.4l-3.1-1.5h3.3c1-4.8 3.7-8.7 4.4-10.7.2-.5.9-2.3 1.1-2.7.1-.1.1-.3.1-.5.1-.3-.4-.8-1-.8z",
  fill: "url(#hero_svg__SVGID_96_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M373.8 10.6c-4.3 1.8-7.7 3.6-8.5 6.6-.8 3.1.3 7.3 1.2 11l.3 1.2c1.1.1 1.9.2 2.6.2l-.4-3.3 2.2 2.9.2-1.9 1.4 1.5c1.9-.8 3.5-2.2 4.6-3.9l-3.7-3.2 4.8 1.1c.7-1.4 1.2-2.9 1.4-4.4l-2.1-1.1s2.4-.3 2.4-.4l-3.1-1.5h3.3c1-4.8 3.7-8.7 4.4-10.7.2-.5.9-2.3 1.1-2.7-3.4 5.1-7.8 6.8-12.1 8.6zm-26.6-4.2c.6-.4 3.3-.1 3.3-.1.6.1 1.1.6.7.9-.8.6-1.9.7-2.8.5-1.3-.2-1.8-.9-1.2-1.3zM347 9c1.5.1.7 1.6-.2 1.8-.9.2-2.3-.3-2.1-.9.1-.6 1.5-.9 2.3-.9zm-4.7-2.9c1.1-.1 2.5 1.1 2.6 1.6.1.6-.7.9-2.6 1.2-1.9.3-3.6-.6-3.6-1.2-.1-.5 2.5-1.4 3.6-1.6zm-17 11c-.7-1.6-1.4-3.9-6.4-5.7h-.1c-.9-.3-3.4-1-5.9-2.5-5.2-3-8.1-6.7-8.1-6.7.2.4.9 2.2 1.1 2.7.8 2.2 4 6.8 4.6 12.4.1.5.2 1.2.3 1.8l3.2.5-2.5 1.9c.7 2.2 2 4.2 3.7 5.8l3.7-1.9-1.4 3.4c1.5.7 3.2 1.1 6.4.7l.3-1.2c.9-3.6 2.3-8.3 1.1-11.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M359.2 28.6c-.2 1.7-1.3 2.7-4.5 2.7-.4 0-.8 0-1.2-.1-3.5-.3-5-.8-8.7-.8-3.7 0-5.3.4-8.7.6h-1.2c-3.2 0-4.4-1-4.5-2.7-2.6 2.1.7 5.2 3.3 6.6 2.6 1.3 5.9 2 10.6 2.2h1c4.7-.1 8-.7 10.6-2 2.4-1.2 5.9-4.3 3.3-6.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st14",
  d: "M331.7 32.9c-.8-.7-2-1.9-1.8-3 0-.1.1-.1.1 0 .5.9 1.6 1.4 2.6 1.6.1 0 .1.1 0 .1l-.9 1.3c.1.1 0 .1 0 0zm1.9 1.4c-.4-.2-.9-.5-1.3-.8-.1 0-.1-.1 0-.2l1-1.4c0-.1.1 0 .1 0l.3 2.2c.1.2 0 .2-.1.2zm.8 0l-.3-2.3c0-.1.1-.3.2-.3h1.8c.2 0 .3.2.2.4l-1.8 2.3s-.1 0-.1-.1zm4 1.6c-1.1-.2-2.2-.5-3.1-.9-.2-.1-.3-.3-.1-.5.5-.7 1.7-2.3 2.1-2.7h.1l1.4 3.6c0 .3-.2.5-.4.5zm1.1-.1l-1.5-3.9c-.1-.2.1-.4.3-.4.4 0 .8-.1 1.2-.1.7-.1 1.4-.2 2.2-.2.2 0 .3.2.2.3l-2.3 4.3h-.1zm4.1.7c-1.1-.1-2-.1-2.9-.2-.2 0-.3-.3-.2-.5l2-3.8c0-.1.1-.1.1 0l1.3 4c.1.3-.1.5-.3.5zm1.1-.4c0 .1-.1.1-.1 0l-1.5-4.7c-.1-.2.1-.4.3-.4h2.8c.2 0 .3.2.3.4l-1.8 4.7zm3.9.2c-.9.1-1.9.2-3 .2-.2 0-.4-.2-.3-.4l1.4-4c0-.1.1-.1.1 0l1.9 3.8c.2.1.1.4-.1.4zm1-.4l-2.3-4.4c-.1-.2 0-.4.2-.3.8.1 1.5.2 2.2.3.4.1.9.1 1.3.2.2 0 .2.2.2.3l-1.6 3.9c.1 0 0 0 0 0zm4.3-.7c-.9.3-2 .6-3.1.8-.2 0-.4-.2-.3-.4l1.4-3.6c0-.1.1-.1.1 0 .3.4 1.5 2.1 2 2.8.2.1.1.3-.1.4zm1.3-3.1l-.4 2.3c0 .1-.1.1-.1 0l-1.7-2.3c-.1-.2 0-.4.2-.4h.1c.5 0 .9.1 1.3.1h.4c.1.1.3.2.2.3zm1.8 1.6c-.4.3-.9.6-1.3.8-.1.1-.2 0-.2-.1l.4-2.2c0-.1.1-.1.1 0l1 1.4v.1zm1.1-1c-.1.1-.3.3-.5.4h-.1l-.9-1.3v-.1c.7-.1 1.2-.3 1.7-.6.4-.3.7-.6 1-1 0-.1.1 0 .1 0v.4c0 .7-.5 1.5-1.3 2.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st9",
  d: "M329.2 17.7c2.5-.1 5.7 2.8 10.5 4.8 1.7.7 3.6 1.3 3.9 1.4.3.1-1.7.2-2.8.3-1.1 1.8-3.1 2.9-5.1 2.8-3.4 0-5-2.1-5.3-4.3-.1-.6-.1-1.2-.1-1.8 0 0 1.5-.2 4.6.6-1.9-1-3.6-1.7-5-1.8-.9 0-1.7.1-2.5.4-.2-.2.2-2.3 1.8-2.4zm31.7 2.2c-1.4.1-3.1.8-5.1 1.7 3.2-.7 4.6-.5 4.6-.5 0 .6 0 1.2-.1 1.8-.4 2.2-2.1 4.2-5.4 4.2-2.1.1-4.1-1-5.1-2.8-1.1-.1-3.1-.3-2.8-.4.3-.1 2.2-.6 3.9-1.3 4.8-1.9 8-4.7 10.5-4.6 1.5.1 1.9 2.2 1.9 2.2-.7-.2-1.6-.3-2.4-.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.8 21.6c3.1-.7 4.6-.5 4.6-.5 0 .6 0 1.2-.1 1.8-.4 2.2-2.1 4.2-5.4 4.2-2.1.1-4-1-5.1-2.9 2.1-.6 4.2-1.6 6-2.6zm-15.1 2.6c-1.1 1.8-3 2.9-5.1 2.8-3.4 0-5-2.1-5.3-4.3-.1-.6-.1-1.2-.1-1.8 0 0 1.5-.2 4.6.6 1.7.9 3.8 2 5.9 2.7z",
  fill: "#23c386"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.7 24.9c.2-1-5-2.3-5-2.3-1.6-.6-1.5.4-1.2 1 .3.5 1.2 2.4 2.8 2.7 1.5.2 3.2-.8 3.4-1.4zm19.6-1.1c-.3.5-1.3 2.3-2.9 2.6-1.6.3-3.2-.5-3.4-1.4-.2-1 5.1-2.2 5.1-2.2.7-.2 1.9-.3 1.2 1z",
  fill: "#69e3b4"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st14",
  d: "M336.7 23.6s1.7.4 1.7 1.2c0 .8-2.5-.9-3.1-1.2-.6-.2 0-.5 1.4 0zm17.2.2s-1.7.4-1.7 1.2c0 .8 2.5-.8 3.1-1.1.7-.3.1-.5-1.4-.1z"
})));

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 680 443.9"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170);
}

export default __webpack_public_path__ + "static/hero.e3faea46.svg";
export { SvgHero as ReactComponent };